import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
import {SET_CUSTOMER} from "@/store/basket/mutation-types";
import debounce from "lodash/debounce";
import Address from "./Address";

export default {
  props: {
    paymentAddress: {
      required: true
    },
    deliveryAddress: {
      required: true
    },
    branchAddress: {
      required: true
    },
    branchAddressLabel: {
      required: false
    },
    deliveryAddressLabel: {
      required: false
    },
    selectedCustomer: {
      required: true
    },
    disabled: {
      default: true
    }
  },
  components: {
    Address
  },
  computed: {
    ...mapState('basket', ['customersOptions', 'addresses', 'customersLoading']),
    ...mapGetters('basket', ['customer', 'payment_address', 'delivery_address', 'payment_address']),
    ...mapGetters('auth', ['getUserConstants', 'isFeatureSupported']),
  },
  methods: {
    ...mapActions('basket', {
      fetchAddresses: 'fetchAddresses',
      updateCheckout: 'updateCheckout',
      searchCustomersAction: 'searchCustomers',
    }),
    ...mapMutations('basket', {
      setCustomerMutation: SET_CUSTOMER
    }),
    searchCustomers: debounce(function (querystring) {
      this.searchCustomersAction(querystring);
    }, 200),
    getDefaultServices(customer) {
        const payload = {};
        if (this.isFeatureSupported('CUSTOMER_DEFAULT_SERVICES')) {
          const deliveryKey = this.getUserConstants('DELIVERY_SERVICE_MODEL');
          const paymentKey = this.getUserConstants('PAYMENT_SERVICE_MODEL');

          const deliveryModel = customer?.[deliveryKey];
          const paymentModel = customer?.[paymentKey];
          if (deliveryModel?.id) {
            payload.delivery_service = {
              id_: deliveryModel.id,
              value_: deliveryModel?.nazev
            };
          }

          if (paymentModel?.id) {
            payload.payment_service = {
              id_: paymentModel.id,
              value_: paymentModel?.nazev
            };
          }
        }

        return payload;
      },
    fetchCustomer(customer) {
      this.fetchAddresses({customer_id: customer.id}).then(() => {
            const services = this.getDefaultServices(customer)
            let data = {
              payment_address: this.addresses.payment_address,
              delivery_address: this.addresses.delivery_address,
              branch_address: this.addresses.branch_address,
              customer: customer,
              ...services
            };
            this.$emit('on-customer-change', data);
          });
    },
    setCustomer(newVal) {
      if (newVal?.id !== this.selectedCustomer?.id) {
        if (newVal != null) {
          this.fetchCustomer(newVal)
        } else {
          this.$emit('on-customer-change', SB_UTILS.getEmptyCustomerModel())
        }
      }
    }
  },
  watch: {
    customer(newCustomer, oldCustomer) {
      if (newCustomer && newCustomer !== oldCustomer && !(this.payment_address && this.delivery_address && this.branchAddress)) {
        this.fetchCustomer(newCustomer)
      }
    },
  },
  created() {
    if (this.customersOptions.length === 0) {
      this.searchCustomersAction('');
    }
  }
}